import type { UseMutateFunction } from '@tanstack/react-query'
import { StudentRequestsForm } from '@/components/student/request-form'
import type { FileUploadStatus } from '@/types/file-upload/file-upload-status'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import type { Request } from '@/types/requests/request'

interface ExternalTransferPreviousEducationDataProps {
  formMethods: StudentRequestedCoursesFormMethods
  fileStatus: FileUploadStatus
  uploadMutation: UseMutateFunction<Request, Error, void, unknown>
  request?: Request
  fileWarning?: string
  requestLabel: string
  disableButtons?: (value: boolean) => void
}

export const ExternalTransferPreviousEducationData = ({
  formMethods,
  request,
  fileStatus,
  fileWarning,
  uploadMutation,
  requestLabel
}: ExternalTransferPreviousEducationDataProps) => {
  const handleFileChange = async (file: File) => {
    if (file && formMethods.trigger) {
      const validFile = await formMethods.trigger('previousEducation.file')
      if (validFile) {
        uploadMutation()
      }
    }
  }
  return (
    <StudentRequestsForm
      requestLabel={requestLabel}
      formMethods={formMethods}
      fileStatus={fileStatus}
      request={request}
      handleFileChange={handleFileChange}
      fileWarning={fileWarning}
    />
  )
}
